import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import "./style.css";
class ChooseSubjectTip extends Component {
  render() {
    return (
      <div className="choose_subject_tip_box">
        此选科是考试院提前公布的要求，部分院校专业并不会在浙招生，实际招生以
        <NavLink to="/intelligentbigdata/home">智能大数据</NavLink>为准
      </div>
    );
  }
}

export default ChooseSubjectTip;



// WEBPACK FOOTER //
// ./src/components/ChooseSubjectTip/index.js